<template>
  <div class="chips">#<slot/></div>
</template>

<script>
export default {
};
</script>

<style lang="scss">
@import '../styles/variables';

.chips {
  display: inline-block;
  background-color: $primary-color;
  padding: 2px;
  margin: 1px 2px;
  font-size: 0.9em;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// Chips.vue?6cd85da4